import { createAsyncThunk } from "@reduxjs/toolkit"
import { Coupon } from "@/types"
import { httpGet, httpPost } from "@/lib/http"

export const fetchAllOffers = createAsyncThunk<Coupon[]>(
  "offers/fetchAll",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpGet({ url: "offers", dispatch })
      return res?.data || []
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)

export const saveOffer = createAsyncThunk<Coupon, Coupon>(
  "offers/save",
  async (offer, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpPost({ url: "admin/offer", payload: offer, dispatch })
      return res?.data || {}
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)
